module.exports = __webpack_public_path__ + "media/Wall of Time (Jail).40c5d612.mp3";